<div class="p-3 rounded-3">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/Dashboard-icon.png" alt="Dashboad" onkeydown="" />
        </div>
        <h3>{{ "Dashboard" }}</h3>
      </div>
    </div>
  </div>
  <div class="container-fluid">

    <!-- KPI row -->
    <div class="row g-3 mb-1">
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <app-stat-card label="Active Clients" icon="check" variant="ok" [value]="clientsCounts?.ActiveCount"
          info="Clients with an active subscription/plan - logged in at least once."></app-stat-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <app-stat-card label="Non-Active Clients" icon="pause" variant="accent" [value]="clientsCounts?.NonActiveCount"
          info="Clients who never logged in - still in Registered or OTP Verified status."></app-stat-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <app-stat-card label="Total Clients" icon="users" variant="brand" [value]="clientsCounts?.TotalCount"
          info="Sum of Active and Non-Active clients."></app-stat-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <app-stat-card label="Total Paid Clients" icon="card" variant="info" [value]="clientsCounts?.PaidClient"></app-stat-card>
      </div>
    </div>

    <!-- Payment dashboard: plan payments coming up, plans that ran out unpaid, and paying clients who stopped logging in -->
    <h4 class="payment-section-title mt-4">Payment Dashboard</h4>
    <div class="row g-3">
      <div class="col-xxl-4 col-xl-6 col-lg-12">
        <div class="card h-100">
          <div class="card-head">
            <div class="payment-head-text">
              <h3>Upcoming Payments <span class="payment-count upcoming">{{ upcomingPayments.length }}</span></h3>
              <span class="payment-subtitle">Payments that are due in the next {{ paymentWindowDays }} days</span>
            </div>
            <span [title]="upcomingPayments.length ? 'Export to Excel' : 'No data to export'">
              <button type="button" class="payment-export" [disabled]="paymentsLoading || !upcomingPayments.length"
                (click)="exportPayments(upcomingPayments, 'Upcoming_Payments')">Export to Excel</button>
            </span>
          </div>
          <div class="card-body">
            <ng-container *ngTemplateOutlet="paymentGrid; context: {
              $implicit: upcomingPayments,
              emptyText: 'No payments due in the next ' + paymentWindowDays + ' days.'
            }"></ng-container>
          </div>
        </div>
      </div>
      <div class="col-xxl-4 col-xl-6 col-lg-12">
        <div class="card h-100">
          <div class="card-head">
            <div class="payment-head-text">
              <h3>Missed Payments <span class="payment-count missed">{{ missedPayments.length }}</span></h3>
              <span class="payment-subtitle">Payments missed during the last {{ paymentWindowDays }} days</span>
            </div>
            <span [title]="missedPayments.length ? 'Export to Excel' : 'No data to export'">
              <button type="button" class="payment-export" [disabled]="paymentsLoading || !missedPayments.length"
                (click)="exportPayments(missedPayments, 'Missed_Payments')">Export to Excel</button>
            </span>
          </div>
          <div class="card-body">
            <ng-container *ngTemplateOutlet="paymentGrid; context: {
              $implicit: missedPayments,
              emptyText: 'No payments missed in the last ' + paymentWindowDays + ' days.'
            }"></ng-container>
          </div>
        </div>
      </div>
      <div class="col-xxl-4 col-xl-6 col-lg-12">
        <div class="card h-100">
          <div class="card-head">
            <div class="payment-head-text">
              <h3>Inactive Paid Clients <span class="payment-count inactive">{{ inactivePaidClients.length }}</span></h3>
              <span class="payment-subtitle">Paid clients not logged in for the past {{ paymentWindowDays }} days</span>
            </div>
            <span [title]="inactivePaidClients.length ? 'Export to Excel' : 'No data to export'">
              <button type="button" class="payment-export" [disabled]="inactiveClientsLoading || !inactivePaidClients.length"
                (click)="exportInactivePaidClients()">Export to Excel</button>
            </span>
          </div>
          <div class="card-body">
            <app-data-grid hoverVariant="muted">
              <kendo-grid [kendoGridBinding]="inactivePaidClients" [loading]="inactiveClientsLoading" [sortable]="true" [height]="340">
                <kendo-grid-column field="ClientName" title="Client Name" [width]="170">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="payment-client">{{ dataItem.ClientName || dataItem.DoctorName }}</div>
                    <div class="payment-meta">{{ dataItem.PlanName }} · {{ dataItem.IsYearly ? 'Yearly' : 'Monthly' }}</div>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="PlanName" title="Plan" [width]="100">
                </kendo-grid-column>
                <kendo-grid-column field="LastLogin" title="Last Login Date" [width]="110">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.LastLogin ? (dataItem.LastLogin | date: 'dd MMM yyyy') : 'Never' }}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="DaysInactive" title="Days Inactive" [width]="100">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="payment-amount">{{ dataItem.DaysInactive != null ? dataItem.DaysInactive + ' days' : '-' }}</span>
                  </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>No inactive paid clients in the past {{ paymentWindowDays }} days.</ng-template>
              </kendo-grid>
            </app-data-grid>
          </div>
        </div>
      </div>
    </div>

    <ng-template #paymentGrid let-rows let-emptyText="emptyText">
      <app-data-grid hoverVariant="muted">
        <kendo-grid [kendoGridBinding]="rows" [loading]="paymentsLoading" [sortable]="true" [height]="340">
          <kendo-grid-column field="ClientName" title="Client Name" [width]="170">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="payment-client">{{ dataItem.ClientName || dataItem.DoctorName }}</div>
              <div class="payment-meta">
                {{ dataItem.PlanName }} · {{ dataItem.IsYearly ? 'Yearly' : 'Monthly' }}
                <span class="payment-autopay" *ngIf="dataItem.IsAutoRenew">AutoPay</span>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="PaymentDue" title="Payment Due" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="payment-amount">
                {{ dataItem.PaymentDue != null ? dataItem.CurrencySymbol + (dataItem.PaymentDue | number: '1.0-2') : '-' }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="LastPaidAmount" title="Last Paid Amount" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.LastPaidAmount != null ? dataItem.CurrencySymbol + (dataItem.LastPaidAmount | number: '1.0-2') : '-' }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="DueDate" title="Date Due" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div>{{ dataItem.DueDate | date: 'dd MMM yyyy' }}</div>
              <div class="payment-meta">{{ dueDayLabel(dataItem.DueDate) }}</div>
            </ng-template>
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate>{{ emptyText }}</ng-template>
        </kendo-grid>
      </app-data-grid>
    </ng-template>

    <div class="row mt-4">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <div class="card h-100">
          <div class="card-head">
            <h3>Active Clients Year wise</h3>
            <div class="toogleBtn">
              <mat-form-field class="mat-datepicker mb-0 app-dp-mat">
                <input matInput [matDatepicker]="dp" placeholder="Year" [formControl]="date">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event, dp)"
                  panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <!--Kendo Graph-->
          <div class="card-body chart-card-body">
            <kendo-chart>
              <kendo-chart-legend position="top"></kendo-chart-legend>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item *ngFor="let item of valueAxes" [min]="item.min" [max]="item.max"
                  [title]="{ text: 'Clients', color: '#044b4f' }">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="categories" [axisCrossingValue]="crossingValues"
                  [title]="{ text: 'Months', color: '#044b4f' }">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-series>
                <kendo-chart-series-item *ngFor="let item of series1" [color]="item.color" [data]="seriesData">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-category="category" let-dataItem="dataItem">
                      Client ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
                <kendo-chart-series-item *ngFor="let item of series2" [color]="item.color" [data]="seriesData2">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-category="category" let-dataItem="dataItem">
                      Patient ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
                <kendo-chart-series-item *ngFor="let item of series3" [color]="item.color" [data]="seriesData3">
                  <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-category="category" let-dataItem="dataItem">
                      Appointment ({{dataItem}})
                    </ng-template>
                  </kendo-chart-series-item-tooltip>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
        <div class="card h-100">
          <div class="card-head">
            <h3>Device Type Count</h3>
            <div class="toogleBtn">
              <mat-form-field class="mat-datepicker mb-0 app-dp-mat">
                <input matInput [matDatepicker]="deviceDp" placeholder="Year" [formControl]="deviceDate">
                <mat-datepicker-toggle matSuffix [for]="deviceDp"></mat-datepicker-toggle>
                <mat-datepicker #deviceDp startView="multi-year"
                  (yearSelected)="deviceYearChosenHandler($event, deviceDp)" panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="card-body chart-card-body">
            <kendo-chart>
              <kendo-chart-legend position="top"></kendo-chart-legend>
              <kendo-chart-tooltip [shared]="true"></kendo-chart-tooltip>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [title]="{ text: 'Count', color: '#044b4f' }">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="categories"
                  [title]="{ text: 'Months', color: '#044b4f' }">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-series>
                <kendo-chart-series-item *ngFor="let s of deviceSeries" type="column" [stack]="true"
                  [name]="s.name" [color]="s.color" [data]="s.data">
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="card h-100 login-activity-card">
          <div class="card-head">
            <h3>Login Activity</h3>
            <div class="login-filters">
              <div class="login-presets" role="group" aria-label="Quick date ranges">
                <button type="button" class="login-preset" *ngFor="let preset of loginRangePresets"
                  [class.active]="loginActivePreset === preset.days" (click)="selectLoginPreset(preset.days)">
                  {{ preset.label }}
                </button>
              </div>
              <div class="login-range">
                <div class="login-range-field">
                  <label class="login-range-label">From</label>
                  <app-date-picker class="login-range-picker" [ngModel]="loginStartPickerDate"
                    [max]="loginEndPickerDate" format="dd MMM yyyy"
                    (ngModelChange)="onLoginDateChange('start', $event)"></app-date-picker>
                </div>
                <div class="login-range-field">
                  <label class="login-range-label">To</label>
                  <app-date-picker class="login-range-picker" [ngModel]="loginEndPickerDate"
                    [max]="loginMaxPickerDate" format="dd MMM yyyy"
                    (ngModelChange)="onLoginDateChange('end', $event)"></app-date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body chart-card-body">
            <div class="login-summary">
            <div class="login-summary-item">
              <span class="login-summary-label">Total logged-in users</span>
              <span class="login-summary-value">{{ loginTotalUsers }}</span>
            </div>
            <div class="login-summary-item">
              <span class="login-summary-label">Total logins</span>
              <span class="login-summary-value">{{ loginTotalLogins }}</span>
            </div>
          </div>
          <div class="login-chart-scroll" #loginChartScroll>
            <kendo-chart #loginChart class="login-days-chart" [style.min-width.px]="loginDayCategories.length * loginPointWidth"
              [style.height.px]="loginChartHeight">
              <kendo-chart-legend position="top"></kendo-chart-legend>
              <kendo-chart-tooltip [shared]="true"></kendo-chart-tooltip>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [majorUnit]="loginMajorUnit"
                  [labels]="{ format: 'n0' }" [title]="{ text: 'Logged-in users', color: '#044b4f' }">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="loginDayCategories" [labels]="{ rotation: 'auto' }"
                  [title]="{ text: loginAxisTitle, color: '#044b4f' }">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-series>
                <kendo-chart-series-item type="line" name="Unique users" color="#044b4f" [data]="loginUsersData"
                  [markers]="{ visible: true, size: 6 }" [style]="'smooth'">
                </kendo-chart-series-item>
                <kendo-chart-series-item type="line" name="Total logins" color="#f9978a" [data]="loginTotalsData"
                  [markers]="{ visible: true, size: 6 }" [style]="'smooth'">
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
